import { IconCircleChevronUpFilled, IconTicket } from "@tabler/icons-react";
import { usePromoCode } from "@/hooks/use-promo-code";
import { useTranslation } from "react-i18next";

interface PromoBannerProps {
  onOpen: () => void;
  className?: string;
  isVisible: boolean;
}

export const PromoBanner = ({ onOpen, className = "", isVisible }: PromoBannerProps) => {
  const { referralCode } = usePromoCode();
  const { t } = useTranslation();

  return (
    <div
      className={`${className} flex justify-center fixed lg:bottom-4 lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:top-auto w-full lg:w-auto lg:z-[60] transition-all duration-300 h-10 lg:h-auto ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 lg:translate-y-4 pointer-events-none'
        }`}
    >
      <div
        onClick={referralCode ? undefined : onOpen}
        className={`bg-sky-600 border-b border-slate-200 rounded-tr-xl rounded-tl-xl lg:bg-sky-600 lg:border lg:border-sky-500 lg:rounded-xl px-4 py-2 lg:px-6 lg:py-3 h-full w-full lg:w-auto flex items-center justify-center gap-2 lg:gap-2.5 lg:shadow-lg ${referralCode ? '' : 'cursor-pointer'}`}
      >
        {referralCode ? (
          <>
            <IconTicket className="w-5 h-5 lg:w-6 lg:h-6 text-slate-50" />
            <div className="text-slate-50 font-medium text-sm lg:text-base tracking-wide whitespace-nowrap">
              {t('promoBanner.applied', { code: referralCode })}
            </div>
          </>
        ) : (
          <>
            <div className="text-slate-50 font-medium text-sm lg:text-base tracking-wide whitespace-nowrap">
              {t('promoBanner.exclusiveDiscount')}
            </div>
            <IconTicket className="w-5 h-5 lg:w-6 lg:h-6 text-slate-50" />
            {/* <IconCircleChevronUpFilled className="w-5 h-5 lg:w-6 lg:h-6 text-slate-50" /> */}
          </>
        )}
      </div>
    </div>
  );
};
